import React from 'react';
import Avatar from './Avatar';

export type SenderProps = {
  image: string;
  name?: string;
  bio?: string;
  subtitle?: string;
  className?: string;
  avatarClassName?: string;
  senderClassName?: string;
  bioClassName?: string;
  subtitleClassName?: string;
};

const Sender = ({
  image,
  name = '',
  bio = '',
  subtitle = '',
  className = '',
  avatarClassName = 'pr-5',
  bioClassName = '',
  senderClassName = '',
  subtitleClassName = '',
}: SenderProps) => (
  <div className={`flex ${className}`}>
    <Avatar image={image} className={avatarClassName} />
    <div className='flex flex-col text-left justify-center'>
      <p
        className={`text-sm text-neutral-600 leading-4 font-medium m-0 ${senderClassName}`}
      >
        {name}
      </p>
      {bio && (
        <p
          className={`text-sm text-neutral-600 leading-4 font-medium m-0 ${bioClassName}`}
        >
          {bio}
        </p>
      )}
      <p
        className={`text-xs text-neutral-400 leading-4 tracking-tighter text m-0 ${subtitleClassName}`}
      >
        {subtitle}
      </p>
    </div>
  </div>
);

export default Sender;
